// project imports
import dashboard from './dashboard';
import pages from './pages';
//import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    //items: [dashboard, pages, other]
    items: [dashboard, pages]
};

export default menuItems;
